<template>
   <Layout>
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Mis Datos</h4>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col-lg-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-4">Datos por Zona {{ zoneSelected }}</h4>
                  <load-spinner v-if="loading"></load-spinner>
                  <mydata-list v-else :data="data[0]" />
               </div>
            </div>
         </div>
      </div>
      <div class="row">
         <div class="col-lg-12">
            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-4">Gráfico</h4>
                  <load-spinner v-if="loading"></load-spinner>
                  <apexchart v-else class="apex-charts" height="350" type="bar" dir="ltr" :series="series" :options="columnChart.chartOptions"></apexchart>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

<script>
   import Layout from '@/layouts/Main'
   import LoadSpinner from '@/components/widgets/LoadSpinner'
   import MydataList from '@/components/widgets/mydata/MydataList'
   import axios from 'axios'

   export default {
      name: 'My-Data',
      data () {
         return {
            loading: true,
            dataComplete: [],
            columnChart: {
               chartOptions: {
                  chart: {
                     toolbar: {
                        show: false,
                     }
                  },
                  plotOptions: {
                     bar: {
                        horizontal: false,
                        columnWidth: '45%',
                        endingShape: 'rounded'
                     },
                  },
                  dataLabels: {
                     enabled: false
                  },
                  stroke: {
                     show: true,
                     width: 2,
                     colors: ['transparent']
                  },
                  colors: ['#34c38f', '#556ee6', '#f46a6a'],
                  xaxis: {
                     categories: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                  },
                  yaxis: {
                     title: {
                        text: 'Euros (€)'
                     }
                  },
                  grid: {
                     borderColor: '#f1f1f1',
                  },
                  fill: {
                     opacity: 1
                  },
                  tooltip: {
                     y: {
                        formatter: function (val) {
                           return val.toFixed(2) + " €"
                        }
                     }
                  }
               }
            }
         }
      },
      computed: {
         zoneSelected() {
            return this.$store.state.user.selectedZone
         },
         data () {
            return this.dataComplete.filter(zone => zone.repres == this.zoneSelected)
         },
         series () {
            var e = this.dataComplete.filter(zone => zone.repres == this.zoneSelected)
            var obj = e[0].obj
            var act = e[0].act
            var ant = e[0].ant

            var series= [
               {
                  name: 'Objetivos',
                  data: [obj.ene, obj.feb, obj.mar, obj.abr, obj.may, obj.jun, obj.jul, obj.ago, obj.sep, obj.oct, obj.nov, obj.dic]
               },
               {
                  name: new Date().getFullYear(),
                  data: [act.ene, act.feb, act.mar, act.abr, act.may, act.jun, act.jul, act.ago, act.sep, act.oct, act.nov, act.dic]
               },
               {
                  name: new Date().getFullYear() - 1,
                  data: [ant.ene, ant.feb, ant.mar, ant.abr, ant.may, ant.jun, ant.jul, ant.ago, ant.sep, ant.oct, ant.nov, ant.dic]
               }
            ]
            return series
         }
      },
      async mounted () {
         let zonas = this.$store.state.user.zones
         let params = "json="+JSON.stringify({ zonas })
          
         await axios({url: 'https://portal.asein.es/api-v2/cargar-objetivos', data: params, method: 'POST' })
         .then(resp => {
            this.dataComplete = resp.data
            this.loading = false
         })
         .catch(err => {
            console.log(err)
         })
      },
      components: {
         Layout, LoadSpinner, MydataList
      }
   }
</script>
